// extracted by mini-css-extract-plugin
module.exports = {"CommentBox":"Comment_CommentBox__dWK90","OwnerName":"Comment_OwnerName__17FH6","Date":"Comment_Date__10qt0","DropdownDots":"Comment_DropdownDots__1RQYF"};